// extracted by mini-css-extract-plugin
export default {"filter-skeleton__container":"styles_filter-skeleton__container__TCm8R"};